export const generateId = (): string => 
  crypto.randomUUID().replace(/[-]/g, "");

export const generateToken = (): string => 
  crypto.randomUUID().replace(/[-]/g, "");

export const generateOTP = (): string => 
  crypto.randomUUID().replace(/[-]/g, "");